import React, { useState, useEffect } from 'react'

//* Style
import CookiePopupStyle from './style'

//* Components
import Text from 'components/common/Text'
import Image from 'components/common/Image'
import CustomLink from 'components/common/CustomLink'

//* Helpers
import { setCookie, getCookie } from 'helpers'

//* config
import { config } from 'helpers'

const CookiePopup = () => {
	const [isCookiePopupAccepted, setIsCookiePopupAccepted] = useState(getCookie('isCookiePopupAccepted'))

	return !isCookiePopupAccepted ? (
		<CookiePopupStyle>
			<div className='FlexBox popup'>
				<Image src='/images/cookie.svg' />
				<div>
					<Text className='inline black maisonMedium' text='popupText' />
					<CustomLink className='p inline black maisonMedium underline' url={config.routes.policy.path}>
						Privacy policy
					</CustomLink>
				</div>
				<button
					className='cookieBtn cursorPointer'
					onClick={() => {
						setCookie('isCookiePopupAccepted', true)
						setIsCookiePopupAccepted(!isCookiePopupAccepted)
					}}
				>
					<Text className='h10 cream maisonSemiBold' text='Accept' />
				</button>
			</div>
		</CookiePopupStyle>
	) : null
}

export default CookiePopup
